
export function PlaceHolder (props: { title: string }): JSX.Element {
  return (<>
    {props.title}
  </>)
}
